import { Component, OnInit, OnDestroy, Input, Output, EventEmitter, ViewChild } from '@angular/core';
// import { MatDialogRef } from '@angular/material';
import { ReportingService } from './reporting.service';

import { LoginService } from '../login/login.service';
import { YearService } from '../../shared-components/year/year.service';
import { LoginSettings } from '../login/LoginSetting.model';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { UserService } from '../../shared-components/user/user.service';

import { ClassroomSummaryService } from '../../classroom360/classroom-summary/classroom-summary.service';
import { StudentService } from '../../shared-components/student/student.service';

import { MyReportsComponent } from './my-reports/my-reports.component';
import { SecurityService } from '../../shared-components/security/security.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@AutoUnsubscribe()
@Component({
    selector: 'report',
    templateUrl: './reporting.component.html'
})

export class ReportingComponent implements OnInit, OnDestroy {
    @ViewChild(MyReportsComponent) myReportsComponent: MyReportsComponent;

    loginSettings: LoginSettings;

    // for expanding/collapsing MyReports folders
    @Output() expandAllFolders: EventEmitter<boolean> = new EventEmitter();
    @Output() hideFoldersButton: EventEmitter<boolean> = new EventEmitter(); // for footer

    @Input() refreshedReportFolders: boolean; // from footer after adding first folder?
    private _isMyReports: boolean;
    private _isAllReports: boolean;
    private _userCanAutoRunReports: boolean;

    get isMyReports(): boolean {
        return this.reportService.isMyReports;
    }

    set isMyReports(value: boolean) {
        this.reportService.isMyReports = value;
    }

    get isAllReports(): boolean {
        return this.reportService.isAllReports;
    }

    set isAllReports(value: boolean) {
        this.reportService.isAllReports = value;
    }

    get userCanAutoRunReports(): boolean {
        return this._userCanAutoRunReports;
    }

    set userCanAutoRunReports(value: boolean) {
        this._userCanAutoRunReports = value;
        this.reportService.userCanAutoRunReports = value;
    }

    private _showNoFoldersMessage: boolean;

    get showNoFoldersMessage(): boolean {
        return this.reportService.showNoFoldersMessage;
    }

    set showNoFoldersMessage(value: boolean) {
        this._showNoFoldersMessage = value;
        this.reportService.showNoFoldersMessage = value;
    }
    showAllReportsComponent: boolean;

    hasClassroom360Role: boolean;
    hasStudent360Role: boolean;
    hasCounselor360Role: boolean;

    allowArchiveReportPDF: boolean;
    utilizeTranscriptTracking: boolean;
    callByV9MyReports = false;



    constructor(
        private reportService: ReportingService,
        private loginService: LoginService,
        private userService: UserService,
        private yearService: YearService,
        private classroomSummaryService: ClassroomSummaryService,
        private studentService: StudentService,
        private securityService: SecurityService,
        private dialogRef: MatDialogRef<ReportingComponent>,
        private dialog: MatDialog,
    ) {
        this.loginSettings = loginService.LoginSettings;

    } // end constructor


    ngOnInit() {
        this.reportService.isMyReports = true; // defaults to my reports
        this.reportService.isAllReports = false;

        this.isMyReports = this.reportService.isMyReports;
        this.isAllReports = this.reportService.isAllReports;

        this.showAllReportsComponent = false;
        this.getUserPermissions();
        this.reportService.maxReportSnapshotAllowed = this.loginService.LoginSettings.MaxReportSnapshotAllowed;
        this.reportService.defaultAcademicYear = this.yearService.defaultYear.AYIdentifier;
        this.reportService.selectedCourse = this.classroomSummaryService.selectedCourse;
        this.reportService.selectedStudent = this.studentService.selectedStudent;
        this.reportService.getReportingConfigurationSettings(this.yearService.defaultYear.SchoolID, this.yearService.defaultYear.AYIdentifier)
            .subscribe(settings => {
                this.reportService.reportingConfigurationSettings = settings;
            });
    }

    ngOnDestroy() {
        // do any necessary cleanup here for instance properties in the reporting service
        this.reportService.autoRunSnapshot = null;
        this.reportService.SelectedReport = null;
        this.reportService.ReportFolders = null;
        this.reportService.ReportFolderToEdit = null;
    }

    getUserPermissions() {

        this.userCanAutoRunReports = this.loginService.LoginSettings.AllowAutoRunReport;

        this.utilizeTranscriptTracking = this.loginService.LoginSettings.UtilizeTranscriptTracking;

        this.allowArchiveReportPDF = this.loginService.LoginSettings.AllowArchiveReportPDF;

        // POST: obtains the permissions from the server
        const permissions = this.securityService.userPermissions;

        // Add/Edit & Autorun Report Configuration & AddEditAutorunConfiguration

        if (permissions.find(permission => permission.PermissionName == 'Report Definition Options')) {
            this.reportService.userHasPrivilegeAddEditDistrictReportDefinitions = true;
        }
        else {
            this.reportService.userHasPrivilegeAddEditDistrictReportDefinitions = false;
        }

        // report archive permissions
        if (permissions.find(permission => permission.PermissionName == 'View Archive Processes From All Users')) {
            this.reportService.viewArchiveProcessesFromAllUsers = true;
        }
        else {
            this.reportService.viewArchiveProcessesFromAllUsers = false;
        }

        if (permissions.find(permission => permission.PermissionName == 'Allow Cancel Archive Processes')) {
            this.reportService.allowCancelArchiveProcesses = true;
        }
        else {
            this.reportService.allowCancelArchiveProcesses = false;
        }

        if (permissions.find(permission => permission.PermissionName == 'Allow Delete Archived Reports')) {
            this.reportService.allowDeleteArchivedReports = true;
        }
        else {
            this.reportService.allowDeleteArchivedReports = false;
        }
    }

    expandAllFoldersClick(expand: any) {
        let expandAll = false;
        if(expand) {
            expandAll = true;
        }
        this.myReportsComponent.expandAllFoldersClick(expandAll);
        if (expand != null) {
            this.expandAllFolders.emit(expandAll);
        }
    }

    reportFoldersRefreshed(wereRefreshed: boolean) {
        if (wereRefreshed == true) {
            this.myReportsComponent.getMyReportFolders();
        }

    }

    closeClick() {
        this.dialog.closeAll();
    }
} // end export class ReportingComponent


